/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Steamfitter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScenarioStatus = 'ready' | 'active' | 'paused' | 'ended' | 'archived' | 'error';

export const ScenarioStatus = {
    Ready: 'ready' as ScenarioStatus,
    Active: 'active' as ScenarioStatus,
    Paused: 'paused' as ScenarioStatus,
    Ended: 'ended' as ScenarioStatus,
    Archived: 'archived' as ScenarioStatus,
    Error: 'error' as ScenarioStatus
};

